import Button from "@/components/ui/button";
import { countries } from "@/constants/countries";
import Link from "next/link";
import { useRouter } from "next/router";
import { Form } from "../FormComps";
import Fieldset from "../ui/Fieldset";
import { En, Fa } from "../ui/multilang";

interface Step2Props {
  handlePrevStep: () => void;
}

export default function Step2({ handlePrevStep }: Step2Props) {
  const { locale } = useRouter();
  const phoneCountryCodes = countries.map((country) => ({
    value: `${country.dial_code}-${country.code}`,
    label: `${country.emoji} ${country.name}`,
  }));
  return (
    <>
      <Form.Input name="firstname" required label={locale === "en" ? "First Name" : "نام"} />
      <Form.Input name="lastname" required label={locale === "en" ? "Last Name" : "نام خانوادگی"} />
      <Fieldset name="phonenumber" legend={locale === "en" ? "Phone" : "تلفن"}>
        <div className={`flex gap-3 ${locale === "fa" ? "flex-row-reverse" : ""}`}>
          <Form.ReactSelect
            name="phoneCountryCode"
            label={locale === "en" ? "Country Code" : "کد کشور"}
            options={phoneCountryCodes}
            required
          />
          <div className="grow">
            <Form.Input name="phone" required label={locale === "en" ? "Number" : "شماره"} dir="ltr" />
          </div>
        </div>
      </Fieldset>
      <div className="h-3"></div>
      <Form.ServerErrorMessage />
      <p className="mb-2">
        <En>
          Registering on Darsoon means you accept our{" "}
          <Link href="/terms-of-use" target="_blank" className="c-prm9">
            Terms and Conditions
          </Link>{" "}
          and{" "}
          <Link href="/privacy-policy" target="_blank" className="c-prm9">
            privacy policy
          </Link>
          .
        </En>
        <Fa>
          ثبت‌نام شما در درسون به معنای پذیرش{" "}
          <Link href="/terms-of-use" target="_blank" className="c-prm9">
            قوانین
          </Link>{" "}
          و{" "}
          <Link href="/privacy-policy" target="_blank" className="c-prm9">
            حریم خصوصی
          </Link>{" "}
          ماست.
        </Fa>
      </p>
      <div className="space-y-4">
        <div className="flex gap-2">
          <Button type="button" variation="soft-prm" onClick={handlePrevStep} className="w-full">
            <En>Previous</En>
            <Fa>مرحله قبل</Fa>
          </Button>
          <Form.SubmitButton width="parent" className="signup-button">
            {locale === "en" ? "Submit" : "ثبت"}
          </Form.SubmitButton>
        </div>
      </div>
    </>
  );
}
